import React from 'react';

import SingleKeycapImage from '../SingleKeycap/SingleKeycapImage.jsx'
import SingleKeycap from './SingleKeycapProduct.jsx'

const DecalLaptop = () => {


  return (
    <div className="decal-laptop">
      <SingleKeycapImage />

      <SingleKeycap />


    </div>
  );
};

export default DecalLaptop;